export const STRATEGY_TYPES = {
    ON_PUSH: 'onpush',
};
